/***
 * This hook is used to store state as a object, which *really* recommended, so use this hook sparingly
 * It's designed to be used in a situation where multiple "state fields" are being updated at once, to reduce
 * re-renders and to eliminate the use of repetitive 'React.useState(...)' in the same Component
 */

import { Reducer, useReducer } from 'react';

const useStateObject = <T>(initialState:T) => {
  return useReducer<Reducer<T, any>>(
    (oldState, newState) => ({ ...oldState, ...newState }), // reducer function
    { ...initialState } // initial state
  );
};

export default useStateObject;